import { AfterContentInit, Component, ContentChildren, Directive, ElementRef, Input, QueryList } from '@angular/core';
import { getParentScroll } from 'ngx-myia-core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[transition-group-item]'
})
export class TransitionGroupItemDirective {
  prevPos: any;

  newPos: any;

  el: HTMLElement;

  moved: boolean;

  moveCallback: any;

  // @Input() transitionDisabled: boolean;


  constructor(elRef: ElementRef) {
    this.el = elRef.nativeElement;
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[transition-group]',
  template: '<ng-content></ng-content>'
})
export class TransitionGroupComponent implements AfterContentInit {
  // tslint:disable-next-line:no-input-rename
  @Input('transition-group') class: string;

  @ContentChildren(TransitionGroupItemDirective) items: QueryList<TransitionGroupItemDirective>;

  _parentScroll: HTMLElement;

  constructor(private _elRef: ElementRef) {
  }

  ngAfterContentInit() {
    this._parentScroll = getParentScroll(this._elRef.nativeElement);
    setTimeout(() => this.refreshPosition('prevPos'), 0); // save init positions on next 'tick'

    this.items.changes.subscribe(items => {
      items.forEach((item: TransitionGroupItemDirective) => item.prevPos = item.newPos || item.prevPos);
      items.forEach(this.runCallback);
      this.refreshPosition('newPos');
      items.forEach((item: TransitionGroupItemDirective) => item.prevPos = item.prevPos || item.newPos); // for new items

      const animate = () => {
        items.forEach(this.applyTranslation);
        // tslint:disable-next-line:no-string-literal
        this['_forceReflow'] = document.body.offsetHeight; // force reflow to put everything in position
        this.items.forEach(this.runTransition.bind(this));
      };

      const willMoveSome = items.some((item: TransitionGroupItemDirective) => {
        const dx = item.prevPos.left - item.newPos.left;
        const dy = item.prevPos.top - item.newPos.top;
        return dx || dy;
      });

      if (willMoveSome) {
        animate();
      } else {
        setTimeout(() => { // for removed items
          this.refreshPosition('newPos');
          animate();
        }, 0);
      }
    });
  }

  runCallback(item: TransitionGroupItemDirective) {
    if (item.moveCallback) {
      item.moveCallback();
    }
  }

  runTransition(item: TransitionGroupItemDirective) {
    if (!item.moved) {
      return;
    }
    const cssClass = this.class + '-move';
    const el = item.el;
    const style: any = el.style;
    el.classList.add(cssClass);
    style.transform = style.WebkitTransform = style.transitionDuration = '';
    el.addEventListener('transitionend', item.moveCallback = (e: any) => {
      if (!e || /transform$/.test(e.propertyName)) {
        el.removeEventListener('transitionend', item.moveCallback);
        item.moveCallback = null;
        el.classList.remove(cssClass);
      }
    });
  }

  refreshPosition(prop: string) {
    this.items.forEach(item => {
      const rect = item.el.getBoundingClientRect();
      item[prop] = {
        left: rect.left,
        top: rect.top
      };
      if (this._parentScroll) {
        const scrollX = this._parentScroll.scrollLeft;
        const scrollY = this._parentScroll.scrollTop;
        item[prop].left += scrollX;
        item[prop].top += scrollY;
      }
    });
  }

  applyTranslation(item: TransitionGroupItemDirective) {
    item.moved = false;
    const dx = item.prevPos.left - item.newPos.left;
    const dy = item.prevPos.top - item.newPos.top;
    if (dx || dy) {
      item.moved = true;
      const style: any = item.el.style;
      style.transform = style.WebkitTransform = 'translate(' + dx + 'px,' + dy + 'px)';
      style.transitionDuration = '0s';
    }
  }
}
